export const getTextDimensions = (text: string): { width: number; height: number } => {
  const tag = document.createElement('div');
  tag.style.position = 'absolute';
  tag.style.margin = '0';
  tag.style.height = '40px';
  tag.style.overflow = 'hidden';
  tag.style.wordBreak = 'break-all';
  tag.style.left = '-99in';
  tag.style.font = 'Nunito';
  tag.innerHTML = text;
  document.body.appendChild(tag);
  const result = { width: tag.clientWidth, height: tag.clientHeight };
  document.body.removeChild(tag);
  return result;
};

export const testCharacterAmountUntilItFitsToWidth = (text: string, preferredWidth: number): number | undefined => {
  for (let i = text.length; i >= 0; i--) {
    const testText = text.substring(0, i);
    if (getTextDimensions(testText).width <= preferredWidth) return i;
  }
  return undefined;
};

export const cutItemTitle = (name: string | { S?: string; N?: string }, width: number): string => {
  const title = typeof name === 'string' ? name : (name?.S || name?.N || '');
  const textDimensions = getTextDimensions(title);
  if (textDimensions.width > width) {
    const characterAmount = testCharacterAmountUntilItFitsToWidth(title, width - 38);
    if (characterAmount === undefined) return title;
    const cutStart = title.substring(0, characterAmount);
    const lastLetters = title.substring(title.length - 4);
    return `${cutStart}...${lastLetters}`;
  }
  return title;
};
